module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать заявку\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'claim-details',
        params: {
          id: _vm.claim.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям заявки")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.claim.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteClaim.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить заявку")]) : _vm._e()]), _vm._v(" "), _c('claim-edit-form', {
    attrs: {
      "claim": _vm.claim
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c9e371","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/claim/ClaimEdit.vue
// module id = 602
// module chunks = 0